// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__5AITi","imageNotLoad":"style_image-not-load__OOBL3","imageWrap":"style_image-wrap__Lp8le","fallback":"style_fallback__ZjBjb"};